import { createAsyncThunk } from '@reduxjs/toolkit';
import { setCompanyId, resetCustomerKYC } from './customerKYCSlice';

// Thunk to set companyId in Redux state (no localStorage persistence — companyId
// is derived from the authenticated user's JWT / auth context on each page load)
export const setCompanyIdAndPersist = createAsyncThunk(
  'customerKYC/setCompanyIdAndPersist',
  async (companyId, { dispatch }) => {
    dispatch(setCompanyId(companyId));
    return companyId;
  }
);

// Thunk to reset KYC state
export const resetCustomerKYCAndClearStorage = createAsyncThunk(
  'customerKYC/resetCustomerKYCAndClearStorage',
  async (_, { dispatch }) => {
    dispatch(resetCustomerKYC());
  }
);
